import { fetcher } from "helpers/fetcher";

import { TGetTicketListReq, TGetTicketListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getTicketList = async (payload: TGetTicketListReq) => {
  return await fetcher<TGetTicketListRes, TGetTicketListReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_TICKET_LIST,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_TICKET_LIST.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
    }
  );
};

export const queryGetTicketList = async (payload: TGetTicketListReq) => {
  return (await getTicketList(payload)).data;
};

queryGetTicketList._key = (payload: TGetTicketListReq) => [
  ENDPOINT.MANAGEMENT.GET_TICKET_LIST.url,
  payload,
];
